import React from 'react';
import { useTranslation } from 'react-i18next';
import { HelpCircle } from 'lucide-react';

export default function FAQ() {
  const { t } = useTranslation('faq');

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <div className="text-center mb-12">
        <HelpCircle className="w-12 h-12 mx-auto text-blue-500 mb-4" />
        <h1 className="text-4xl font-bold text-gray-900 mb-4">{t('title')}</h1>
        <p className="text-lg text-gray-600">{t('subtitle')}</p>
      </div>

      <div className="space-y-8">
        <section>
          <h2 className="text-2xl font-semibold text-gray-900 mb-6">{t('general.title')}</h2>
          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">{t('general.what.title')}</h3>
              <p className="text-gray-600">{t('general.what.description')}</p>
            </div>
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">{t('general.free.title')}</h3>
              <p className="text-gray-600">{t('general.free.description')}</p>
            </div>
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">{t('general.secure.title')}</h3>
              <p className="text-gray-600">{t('general.secure.description')}</p>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-900 mb-6">{t('usage.title')}</h2>
          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">{t('usage.duration.title')}</h3>
              <p className="text-gray-600">{t('usage.duration.description')}</p>
            </div>
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">{t('usage.viewLimit.title')}</h3>
              <p className="text-gray-600">{t('usage.viewLimit.description')}</p>
            </div>
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">{t('usage.edit.title')}</h3>
              <p className="text-gray-600">{t('usage.edit.description')}</p>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gray-900 mb-6">{t('security.title')}</h2>
          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">{t('security.encryption.title')}</h3>
              <p className="text-gray-600">{t('security.encryption.description')}</p>
            </div>
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">{t('security.expiration.title')}</h3>
              <p className="text-gray-600">{t('security.expiration.description')}</p>
            </div>
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">{t('security.recovery.title')}</h3>
              <p className="text-gray-600">{t('security.recovery.description')}</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}